module.exports = __webpack_public_path__ + "/assets/sounds/plop.mp3";